import * as Redux from 'redux';
import logger from 'redux-logger';
import thunkMiddleware from 'redux-thunk';

import Logging from '~app/core/logging';
import rootReducer from '~app/reducers';

const log = Logging.getLogger('app.actionLog');

function createStore(initialState) {
  // ======================================================
  // Middleware Configuration
  // ======================================================
  const middleware = [
    thunkMiddleware,
  ];

  // enable the logger if TRACE level is available
  // logging must be last in the middleware stack
  if (log.isEnabledFor(Logging.LOG_LEVELS.TRACE)) {
    middleware.push(logger);
  }

  // ======================================================
  // Store Enhancers
  // ======================================================
  let composeEnhancers = Redux.compose;
  if (process.env.NODE_ENV !== 'production') {
    composeEnhancers = (
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ||
      Redux.compose
    );
  }

  // ======================================================
  // Store Instantiation
  // ======================================================
  const store = Redux.createStore(
    rootReducer,
    initialState,
    composeEnhancers(
      Redux.applyMiddleware(...middleware),
    )
  );

  return store;
}

export default createStore;



// WEBPACK FOOTER //
// ./src/createStore.js